import { BottomAction } from '@euler/app/components/BottomAction';
import { WeChatPayIcon } from '@euler/app/components/icons/WechatPayIcon';
import { Typography } from '@euler/app/components/typography';
import { useWeixinLoginBinding } from '@euler/app/flows/settings/functions';
import type { SettingsNavParams } from '@euler/app/flows/settings/screens';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import {
  useScreenContentContainerStyle,
  wrapNavigatorScreen,
} from '@euler/functions/wrapNavigatorScreen';
import { useServiceFactory } from '@euler/services/factory';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useCallback } from 'react';
import { ScrollView } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const WithdrawWeixinAuthScreen = wrapNavigatorScreen(
  () => {
    const { bottom } = useSafeAreaInsets();
    const contentContainerStyle = useScreenContentContainerStyle();
    const { rpx } = useResponsiveContext();
    const { userService } = useServiceFactory();
    const { bindAsync } = useWeixinLoginBinding();
    const navigation = useNavigation<StackNavigationProp<SettingsNavParams>>();

    const onAuthorize = useCallback(async () => {
      try {
        await bindAsync();
        const binding = await userService.getWeixinLoginBindInfo();
        if (binding == null) return;
        navigation.replace('_withdraw', { binding });
      } catch (e) {
        alert((e as any).message);
      }
    }, [bindAsync, navigation, userService]);

    return (
      <ScrollView
        contentContainerStyle={[
          {
            paddingBottom: bottom + rpx(120),
            paddingTop: rpx(30),
            paddingLeft: rpx(30),
            paddingRight: rpx(30),
            flexGrow: 1,
            alignItems: 'center',
            justifyContent: 'center',
          },
          contentContainerStyle,
        ]}
      >
        <WeChatPayIcon size={rpx(80)} />
        <Typography.Title level={1} align="center" size={rpx(28)}>
          微信授权
        </Typography.Title>
        <Typography.Paragraph
          align="center"
          size={rpx(17)}
          lineHeight={rpx(28)}
          color="#555"
          css={`
            margin: ${rpx(30)}px 0;
          `}
        >
          您尚未绑定微信，请授权并绑定微信，之后我们会将奖励提现至您的微信零钱钱包！
        </Typography.Paragraph>
        <BottomAction.Button
          text="开始微信授权"
          onPress={onAuthorize}
          css={`
            align-self: stretch;
          `}
        />
      </ScrollView>
    );
  },
  { title: '奖励提现' },
);
